/* Copyright (c) 2018 Scaper */

export * from "./app/addPaymentMethod/addPaymentMethodPath";
export * from "./app/appPath";
export * from "./app/confirmPhoneNumber/confirmPhoneNumberPath";
export * from "./app/profile/profilePath"
export * from "./app/payment/paymentPath";
export * from "./app/setPhoneNumber/setPhoneNumberPath";
export * from "./app/signIn/signInPath";

export * from "./aboutUs/aboutUsPath";
export * from "./becomeAScaper/becomeAScaperPath";
export * from "./homeowners/homeownersPath";
